import { Link, useLocation } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import React from 'react';

import { useAuth } from '@/shared/contexts/AuthContext';
import { TOUR_STEP_COUNT } from '@/components/common/OnboardingTour';

/**
 * A banner shown on non-dashboard pages when the user has an incomplete
 * onboarding tour. Lets them easily navigate back to the dashboard to
 * resume the tour from where they left off.
 */
export default function ContinueTourBanner() {
    const { hasSeenTour, tourStep, hasProfile } = useAuth();
    const { pathname } = useLocation();

    // Only show for authenticated users with a profile who haven't finished the tour
    if (!hasProfile || hasSeenTour !== false) return null;

    // Don't show on the dashboard itself (tour launches there automatically)
    if (pathname === '/dashboard') return null;

    const progress = Math.round(((tourStep || 0) / TOUR_STEP_COUNT) * 100);

    return (
        <Alert
            variant="primary"
            className="mb-0 rounded-0 border-0 border-bottom py-2 text-center"
            dismissible={false}
        >
            <div className="d-flex align-items-center justify-content-center gap-3 flex-wrap">
                <span className="small">
                    You&apos;re {progress}% through the platform tour.
                </span>
                <Button
                    as={Link}
                    to="/dashboard"
                    variant="outline-dark"
                    size="sm"
                    className="rounded-pill fw-medium"
                >
                    Continue Tour
                </Button>
            </div>
        </Alert>
    );
}
